import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import userService from 'services/UserService';
import { SignInResultType } from 'services/EnumConstants';
import ComponentContainer from 'containers/ComponentContainer';
import ResetPasswordWeb from './ResetPasswordWeb';
import ResetPasswordMobile from './ResetPasswordMobile';
import 'extensions/urlSearchParamsExtensions';

class ResetPasswordWrapper extends Component {
    state = {
        loading: true,
        newPassword: '',
        confirmNewPassword: '',
        email: '',
        code: '',
        codeType: '',
        showError: false,
        forgotPasswordLink: '/app/forgotpassword'
    };
    
    render() {
        const { loginConfig } = this.props;
        return (
            <ComponentContainer loading={this.state.loading}>

                {(props) => {
                    this.parentProps = props;

                    return (
                        <div>
                            {loginConfig.formType === 'web' ?
                                <ResetPasswordWeb data={this.state} onSubmit={this.handleSubmit} loginConfig={loginConfig} />
                                :
                                <ResetPasswordMobile data={this.state} onSubmit={this.handleSubmit} loginConfig={loginConfig} intl={this.parentProps.intl} />
                            }
                        </div>
                    );
                }}

            </ComponentContainer>
        );
    }

    componentDidMount() {
        let queryString = this.props.search;

        if (queryString) {
            let searchParams = new URLSearchParams(encodeURI(queryString));
            let forgotPasswordLink = `/app/forgotpassword?ReturnUrl=${searchParams.getIgnoreCase('returnUrl')}`;
            let missingCodeMessage = this.parentProps.intl.formatMessage({ id: 'resetPassword.missingCode' });
            // the new formatMessage doesn't handle the html in this message, so replacing link value this way
            missingCodeMessage = missingCodeMessage.replace(`{link}`, forgotPasswordLink);

            this.setState({
                email: searchParams.getIgnoreCase('email'),
                code: searchParams.getIgnoreCase('code'),
                codeType: searchParams.getIgnoreCase('codeType'),
                returnUrl: searchParams.getIgnoreCase('returnUrl'),
                missingCodeMessage,
                loading: false
        });
        } else {
            this.setState({ showError: true, loading: false });
        }
    }

    handleSubmit = (values, props) => {
        const { setSubmitting } = props;
        const { newPassword, confirmNewPassword, email, code, codeType, returnUrl } = values;

        setSubmitting(true);

        userService
            .resetPassword(email, code, codeType, newPassword, confirmNewPassword, returnUrl)
            .then((result) => {
                setSubmitting(false);
                this.passwordChanged(result);
            })
            .catch(() => this.setState({ showError: true }));
    };

    passwordChanged = (result) => {
        const { history } = this.props;
        let resultTypeCode = result.result;
        let redirectUrl = '';

        if (resultTypeCode === SignInResultType.Success) {
            redirectUrl = result.validatedRedirectUri;
        }

        history.push(`/app/resetPasswordConfirmation?redirectUrl=${redirectUrl}`);
    };
}

export default withRouter(ResetPasswordWrapper);
